<template>
  <div class="dropdown z-index-10-fg reminders-menu">
    <ul>
      <li class="clear-all" v-if="reminders.length > 1">
        <div class="container"><span class="link" @click="clearAllReminders">Clear All Reminders</span></div>
      </li>
      <li v-for="reminder in reminders" @click="$emit('selectReminder', reminder.REMINDERID)">
        <div class="container">
          <div>
            <img src="../assets/warning.svg" />
            <p>{{ getReminderName(reminder) }}</p>
            <p>{{ formatDate(reminder.DATE) }}</p>
          </div>
          <p>{{ decryptSymbols(reminder.TEXT) }}</p>
        </div>
      </li>
    </ul>
  </div>
  <div class="screen-overlay-clear z-index-10-bg" @click="$emit('closeDropdown')"></div>
</template>

<script>
import useDecryptSymbols from '@/composables/useDecryptSymbols';
import useReminderMutate from '@/composables/useReminderMutate';

export default {
  name: 'RemindersMenu',
  setup() {
    const { decryptSymbols } = useDecryptSymbols();
    const { clearUserReminders } = useReminderMutate();

    return {
      decryptSymbols,
      clearUserReminders,
    };
  },
  emits: ['closeDropdown', 'selectReminder'],
  props: {
    reminders: Array,
  },
  methods: {
    formatDate(date) {
      const today = new Date();
      const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      const twoDaysAgo = new Date(today);
      twoDaysAgo.setDate(today.getDate() - 2);
      const threeDaysAgo = new Date(today);
      threeDaysAgo.setDate(today.getDate() - 3);
      const fourDaysAgo = new Date(today);
      fourDaysAgo.setDate(today.getDate() - 4);
      const fiveDaysAgo = new Date(today);
      fiveDaysAgo.setDate(today.getDate() - 5);
      const sixDaysAgo = new Date(today);
      sixDaysAgo.setDate(today.getDate() - 6);
      const sevenDaysAgo = new Date(today);
      sevenDaysAgo.setDate(today.getDate() - 7);

      const reminderDate = new Date(parseInt(date));

      if (reminderDate.toDateString() === today.toDateString()) {
        return `Today, ${reminderDate.getMonth() + 1}/${reminderDate.getDate()}/${reminderDate.getFullYear()}`;
      } else if (reminderDate.toDateString() === yesterday.toDateString()) {
        return `Yesterday, ${reminderDate.getMonth() + 1}/${reminderDate.getDate()}/${reminderDate.getFullYear()}`;
      } else if (reminderDate.toDateString() === twoDaysAgo.toDateString()) {
        return `Last ${weekdays[reminderDate.getDay()]}, ${reminderDate.getMonth() + 1}/${reminderDate.getDate()}/${reminderDate.getFullYear()}`;
      } else if (reminderDate.toDateString() === threeDaysAgo.toDateString()) {
        return `Last ${weekdays[reminderDate.getDay()]}, ${reminderDate.getMonth() + 1}/${reminderDate.getDate()}/${reminderDate.getFullYear()}`;
      } else if (reminderDate.toDateString() === fourDaysAgo.toDateString()) {
        return `Last ${weekdays[reminderDate.getDay()]}, ${reminderDate.getMonth() + 1}/${reminderDate.getDate()}/${reminderDate.getFullYear()}`;
      } else if (reminderDate.toDateString() === fiveDaysAgo.toDateString()) {
        return `Last ${weekdays[reminderDate.getDay()]}, ${reminderDate.getMonth() + 1}/${reminderDate.getDate()}/${reminderDate.getFullYear()}`;
      } else if (reminderDate.toDateString() === sixDaysAgo.toDateString()) {
        return `Last ${weekdays[reminderDate.getDay()]}, ${reminderDate.getMonth() + 1}/${reminderDate.getDate()}/${reminderDate.getFullYear()}`;
      } else if (reminderDate.toDateString() === sevenDaysAgo.toDateString()) {
        return `Last ${weekdays[reminderDate.getDay()]}, ${reminderDate.getMonth() + 1}/${reminderDate.getDate()}/${reminderDate.getFullYear()}`;
      } else {
        return `${reminderDate.getMonth() + 1}/${reminderDate.getDate()}/${reminderDate.getFullYear()}`;
      }
    },
    getReminderName(reminder) {
      if (reminder.company) {
        return reminder.company.NAME;
      } else if (reminder.contact) {
        return `${reminder.contact.FIRSTNAME} ${reminder.contact.LASTNAME}`;
      } else if (reminder.lead) {
        if (reminder.lead.company) {
          return reminder.lead.company.NAME;
        } else if (reminder.lead.contact) {
          return `${reminder.lead.contact.FIRSTNAME} ${reminder.lead.contact.LASTNAME}`;
        } else {
          return reminder.lead.NAME;
        }
      }
      return '';
    },
    async clearAllReminders() {
      await this.clearUserReminders();
      this.$emit('closeDropdown');
    },
  },
};
</script>

<style lang="scss" scoped>
.reminders-menu {
  width: 25rem;
  max-height: 75vh;
  overflow-y: auto;

  ul {
    padding: 0;
    li {
      display: flex;
      flex-direction: column;
      padding: 0;
      margin: 0;
      border-radius: $borderRadius5;

      &:hover:not(.clear-all) {
        background-color: $appBackgroundColor;
        cursor: pointer;
      }

      &:not(:last-of-type) {
        .container {
          border-bottom: 1px solid $tableBorderColor;
        }
      }
      .container {
        margin: 0.8rem;
        margin-bottom: 0;
        padding-bottom: 0.8rem;

        div {
          display: flex;
          align-items: center;

          img {
            width: 0.9rem;
            height: 0.9rem;
            margin-right: 0.5rem;
          }

          p:first-of-type {
            font-size: $fontSize10;
            margin-right: 1rem;
            flex: 1;
            color: $textColor87;
            margin: 0;
          }
          p:last-of-type {
            color: $textColor38;
            font-size: $fontSize10;
            margin: 0;
          }
        }

        p {
          font-size: $fontSize12;
          color: black;
          margin: 0;
          margin-top: 0.6rem;
          text-wrap: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      &.clear-all {
        .container {
          font-size: $fontSize12;
          text-align: right;
        }
      }
    }
  }
}
</style>
